export default {
  "navBar": {
    "lang": "Languages"
  }
};
